var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { transformArrayToQueryParams } from '../utils/stringify';
import { Api } from './Api';
const service = {
    user: 'user',
    order: 'order',
    company: 'company'
};
const controller = {
    activeReportPackages: 'service-packages/active',
    customerActiveReportPackages: 'service-packages/customer/active',
    individuals: 'individuals',
    individualsCompany: 'individuals/company',
    changePassword: 'authentication/change-password',
    companies: 'companies',
    connectedUsers: 'customers/users',
    costCenter: 'cost-centers',
    countries: 'countries',
    customers: 'customers',
    customersCompany: 'customers/company',
    customersnames: 'customers/names',
    departments: 'departments',
    internationalIndividual: 'internationalindividuals',
    internationalIndividualCompany: 'internationalindividuals/company',
    fileStorage: 'filestorage',
    groupOrders: 'orders/group',
    internalUsers: 'internal-users',
    reportPackages: 'service-packages/company',
    textHandler: 'text-handlers',
    internationalOrder: 'orders/international',
    orders: 'orders',
    place: 'orders/place',
    companyOrders: 'orders/company',
    checkNationalId: 'orders/checkIndividualNationalId'
};
export class Network {
    constructor() {
        this.api = new Api();
        this.authenticate = this.api.authenticate;
    }
    getActiveCompanyReportPackages(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api
                .getDataFromServiceById(service.order, controller.customerActiveReportPackages, companyId)
                .then(result => result.data)
                .catch(err => console.error(err));
        });
    }
    getCheckpointsByType(type) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.getDataFromService(service.order, `checkpoints/${type}`);
            return response.data;
        });
    }
    getConcernFlat(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api
                .getDataFromServiceById(service.company, 'companies', `${companyId}?subsidiaries=true&flat=true`)
                .then(result => result.data)
                .catch(err => console.error(err));
        });
    }
    getCompanyDataById(companyId, subsidiaries, flat) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api
                .getDataFromServiceSubsidiaries(service.company, controller.companies, companyId, subsidiaries, flat)
                .then(value => value.data)
                .catch(reason => console.error('Error fetching company data:', reason));
        });
    }
    getCompanyInvoicing(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield this.api.getCompanyInvoicingService(`invoicing-customer.tofindout.se/api/Invoice/Customer/Configuration/${companyId}`);
            return response.data;
        });
    }
    getUsers(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api
                .getDataFromServiceById(service.user, controller.customers, userId)
                .then(response => response.data)
                .catch(err => console.error(err));
        });
    }
    getResearcherById(researcherId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api
                .getDataFromServiceById(service.user, controller.internalUsers, researcherId)
                .then(result => result.data)
                .catch(error => (console.error('Failed to fetch data', error), error));
        });
    }
    getResearcherById2(researcherId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.getDataFromServiceById(service.user, controller.internalUsers, researcherId);
        });
    }
    getIndividualsByCompanyId(companyId, international) {
        return __awaiter(this, void 0, void 0, function* () {
            let typeOfIndividual = international ? controller.internationalIndividualCompany : controller.individualsCompany;
            return yield this.api
                .getDataFromServiceById(service.user, typeOfIndividual, companyId)
                .then(result => result.data)
                .catch(err => console.error(err));
        });
    }
    getOrdersByStates(states, companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            var queryParams = transformArrayToQueryParams('orderstates', states);
            return this.api
                .getDataFromServiceByIdAndType(service.order, controller.companyOrders, companyId, `states?${queryParams}`)
                .then(value => {
                return value.data;
            })
                .catch(rejected => {
                console.error(rejected);
                return {};
            });
        });
    }
}
export class GetReportDataProps {
}
